/*
 * Author: Dw
 * File Created: Monday, 25-06-16 10:47 am
 * Last Modified: Monday, 25-06-16 10:48 am, by Dw
 */

import type { ICaptchaInstance, ICaptchaProvider } from '../types';

const dummy: ICaptchaInstance = {
  show() {
    // intentionally left blank
  },
  reset() {
    // intentionally left blank
  },
  destroy() {
    // intentionally left blank
  },
};

export const noneProvider: ICaptchaProvider = {
  async init() {
    // 立即 ready
    return dummy;
  },
};
